import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { useTypedParams, useTypedSearchParams } from 'react-router-typesafe-routes';
import AppHeader from '@/components/layouts/page-layout/app-header';
import AppHeaderMenu from '@/components/layouts/page-layout/app-header-menu';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import SearchMessageResultDetail from '@/components/search/search-message-result-detail';
import useSearchMessages from '@/hooks/search/use-search-messages';
import { useIsDesktop } from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { generateSessionKey } from '@/utils/session';

export default function GlobalSearchBySessionRoute() {
  const { t } = useTranslation();
  const { session } = useTypedParams(ROUTES.SEARCH.BY_SESSION);
  const [{ keyword: searchKeyword = '' }] = useTypedSearchParams(ROUTES.SEARCH.BY_SESSION);
  const { messages } = useSearchMessages(searchKeyword);
  const isDesktop = useIsDesktop();

  const selectedMessageSet = useMemo(
    () =>
      session
        ? messages.find((m) => {
            const key =
              m.GroupId > 0 ? generateSessionKey('group', m.GroupId) : generateSessionKey('session', m.ChatSessionId);
            return key === session;
          })
        : undefined,
    [messages, session],
  );

  if (!selectedMessageSet)
    return (
      <Navigate
        replace
        to='..'
      />
    );

  return (
    <PageLayout
      constrainHeight
      enablePullToRefresh={false}
      className='gap-y-0 max-w-100vw overflow-hidden'
      title={t('search.placeholder')}
      headerConfig={{
        navigateBack: true,
        headerLabel: <h5 className='flex-1 text-body1 font-bold text-center'>{selectedMessageSet?.SessionName}</h5>,
        elementBeforeNav: isDesktop && (
          <AppHeader
            actions={<AppHeaderMenu />}
            className='flex-1 text-left text-2xl font-bold'>
            {t('nav.messages')}
          </AppHeader>
        ),
      }}>
      {session && selectedMessageSet ? (
        <SearchMessageResultDetail
          keyword={searchKeyword}
          selectedMessageSet={selectedMessageSet}
        />
      ) : null}
    </PageLayout>
  );
}
